import { render } from "./UserProfilePics.vue?vue&type=template&id=655d2fd7&scoped=true"
import script from "./UserProfilePics.vue?vue&type=script&lang=js"
export * from "./UserProfilePics.vue?vue&type=script&lang=js"

import "./UserProfilePics.vue?vue&type=style&index=0&id=655d2fd7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655d2fd7"]])

export default __exports__